<script setup>
import { defineProps, defineOptions, ref } from "vue";
import GenericModal from "./GenericModal.vue";

defineOptions({ name: "ViewPDF" });
const props = defineProps({
  url: { type: String, required: true },
  show: { type: Boolean, required: true },
});
</script>

<template>
  <GenericModal class="flex flex-col items-center modal">
    <div class="pdf-container">
      <iframe
        :src="props.url"
        width="100%"
        height="500"
        style="border: none"
        allow="cross-origin-isolated;"
        referrerpolicy="no-referrer"
        credentialless
        allowfullscreen
      ></iframe>
    </div>
  </GenericModal>
</template>

<style scoped>
.sticky {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: white;
  padding: 15px 0;
}
.modal {
  max-width: 75%;
}
.pdf-container {
  width: 500px;
  height: 100%;
}
</style>
